import { CircularProgress, Drawer, Stack } from "@mui/material";
import { useMemo } from "react";
import { OnlineVisit } from "src/api/types";
import Answers from "src/components/PatientIntakes/components/Answers";

interface Props {
  open: boolean;
  onClose: () => void;
  visit: OnlineVisit | undefined;
  loadingVisit: boolean;
}

const IntakeDrawer = ({ onClose, open, visit, loadingVisit }: Props) => {
  const intakeSlug = useMemo(() => {
    if (visit == null) return null;

    return visit.slug;
  }, [visit]);

  return (
    <Drawer
      open={open}
      onClose={onClose}
      anchor="right"
      sx={{
        "& .MuiDrawer-paper": {
          width: 500,
          padding: 2,
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      {loadingVisit ? (
        <CircularProgress />
      ) : (
        <Stack sx={{ flex: 1, overflow: "hidden" }}>
          <Answers intakeSlug={intakeSlug} />
        </Stack>
      )}
    </Drawer>
  );
};

export default IntakeDrawer;
